// extracted by mini-css-extract-plugin
module.exports = {"container":"FailedLogin_container__2Nzl0","errorContainer":"FailedLogin_errorContainer__15RDa","errorModal":"FailedLogin_errorModal__1KDfy","text":"FailedLogin_text__16za3"};